import { render, staticRenderFns } from "./cModalAtender.vue?vue&type=template&id=1d363654&scoped=true"
import script from "./cModalAtender.vue?vue&type=script&lang=js"
export * from "./cModalAtender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d363654",
  null
  
)

export default component.exports